"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.areasAll = void 0;
const areasAll = [
    {
        "id": "137",
        "name": "Western Australia",
        "countryId": "202"
    },
    {
        "id": "138",
        "name": "South Australia",
        "countryId": "202"
    },
    {
        "id": "139",
        "name": "Northern Territory",
        "countryId": "202"
    },
    {
        "id": "140",
        "name": "Victoria",
        "countryId": "202"
    },
    {
        "id": "141",
        "name": "Tasmania",
        "countryId": "202"
    },
    {
        "id": "142",
        "name": "Queensland",
        "countryId": "202"
    },
    {
        "id": "143",
        "name": "New South Wales",
        "countryId": "202"
    },
    {
        "id": "144",
        "name": "Australian Capital Territory",
        "countryId": "202"
    },
    {
        "id": "993",
        "name": "Wales",
        "countryId": "30"
    },
    {
        "id": "994",
        "name": "Scotland",
        "countryId": "30"
    },
    {
        "id": "995",
        "name": "N Ireland",
        "countryId": "30"
    },
    {
        "id": "996",
        "name": "England",
        "countryId": "30"
    },
    {
        "id": "3578",
        "name": "Arkansas",
        "countryId": "82"
    },
    {
        "id": "3579",
        "name": "Washington, D.C.",
        "countryId": "82"
    },
    {
        "id": "3580",
        "name": "Delaware",
        "countryId": "82"
    },
    {
        "id": "3581",
        "name": "Florida",
        "countryId": "82"
    },
    {
        "id": "3582",
        "name": "Georgia",
        "countryId": "82"
    },
    {
        "id": "3583",
        "name": "Kansas",
        "countryId": "82"
    },
    {
        "id": "3584",
        "name": "Louisiana",
        "countryId": "82"
    },
    {
        "id": "3585",
        "name": "Maryland",
        "countryId": "82"
    },
    {
        "id": "3586",
        "name": "Missouri",
        "countryId": "82"
    },
    {
        "id": "3587",
        "name": "Mississippi",
        "countryId": "82"
    },
    {
        "id": "3588",
        "name": "North Carolina",
        "countryId": "82"
    },
    {
        "id": "3589",
        "name": "Oklahoma",
        "countryId": "82"
    },
    {
        "id": "3590",
        "name": "South Carolina",
        "countryId": "82"
    },
    {
        "id": "3591",
        "name": "Tennessee",
        "countryId": "82"
    },
    {
        "id": "3592",
        "name": "Texas",
        "countryId": "82"
    },
    {
        "id": "3593",
        "name": "West Virginia",
        "countryId": "82"
    },
    {
        "id": "3594",
        "name": "Alabama",
        "countryId": "82"
    },
    {
        "id": "3595",
        "name": "Connecticut",
        "countryId": "82"
    },
    {
        "id": "3596",
        "name": "Iowa",
        "countryId": "82"
    },
    {
        "id": "3597",
        "name": "Illinois",
        "countryId": "82"
    },
    {
        "id": "3598",
        "name": "Indiana",
        "countryId": "82"
    },
    {
        "id": "3599",
        "name": "Maine",
        "countryId": "82"
    },
    {
        "id": "3600",
        "name": "Michigan",
        "countryId": "82"
    },
    {
        "id": "3601",
        "name": "Minnesota",
        "countryId": "82"
    },
    {
        "id": "3602",
        "name": "Nebraska",
        "countryId": "82"
    },
    {
        "id": "3603",
        "name": "New Hampshire",
        "countryId": "82"
    },
    {
        "id": "3604",
        "name": "New Jersey",
        "countryId": "82"
    },
    {
        "id": "3605",
        "name": "New York",
        "countryId": "82"
    },
    {
        "id": "3606",
        "name": "Ohio",
        "countryId": "82"
    },
    {
        "id": "3607",
        "name": "Rhode Island",
        "countryId": "82"
    },
    {
        "id": "3608",
        "name": "Vermont",
        "countryId": "82"
    },
    {
        "id": "3609",
        "name": "Wisconsin",
        "countryId": "82"
    },
    {
        "id": "3610",
        "name": "California",
        "countryId": "82"
    },
    {
        "id": "3611",
        "name": "Colorado",
        "countryId": "82"
    },
    {
        "id": "3612",
        "name": "New Mexico",
        "countryId": "82"
    },
    {
        "id": "3613",
        "name": "Nevada",
        "countryId": "82"
    },
    {
        "id": "3614",
        "name": "Utah",
        "countryId": "82"
    },
    {
        "id": "3615",
        "name": "Arizona",
        "countryId": "82"
    },
    {
        "id": "3616",
        "name": "Idaho",
        "countryId": "82"
    },
    {
        "id": "3617",
        "name": "Montana",
        "countryId": "82"
    },
    {
        "id": "3618",
        "name": "North Dakota",
        "countryId": "82"
    },
    {
        "id": "3619",
        "name": "Oregon",
        "countryId": "82"
    },
    {
        "id": "3620",
        "name": "South Dakota",
        "countryId": "82"
    },
    {
        "id": "3621",
        "name": "Washington",
        "countryId": "82"
    },
    {
        "id": "3622",
        "name": "Wyoming",
        "countryId": "82"
    },
    {
        "id": "3623",
        "name": "Hawaii",
        "countryId": "82"
    },
    {
        "id": "3624",
        "name": "Alaska",
        "countryId": "82"
    },
    {
        "id": "3625",
        "name": "Kentucky",
        "countryId": "82"
    },
    {
        "id": "3626",
        "name": "Massachusetts",
        "countryId": "82"
    },
    {
        "id": "3627",
        "name": "Pennsylvania",
        "countryId": "82"
    },
    {
        "id": "3628",
        "name": "Virginia",
        "countryId": "82"
    }
];
exports.areasAll = areasAll;
//# sourceMappingURL=areas.js.map